import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TestAlertsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      aircraft_models_list: [],
      schedules_list: [],
      aircrafts_list: [],
      staff_list: [],
      schedule_id: null,
      schedule_grade_aircraft_id: null,
      aircraft_model_id: null,
      staff_enrolled_id: null,
      staff_id: null,
      aircraft_selected: 0,
      aircraft_model_selected: 0,
      schedule_selected: 0,
      alerts_sent: 0,
      alerts: {},
   };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.test = this.test.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearStaffSelect();
    } else {
      this.handleAlert('', '', 'open');
      change[name] = event.value;
      var datasave = {
        schedule_id: this.state.schedule_id,
        schedule_grade_aircraft_id: event.value,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/tripulantes/escalados/aeronave/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          self.setState({staff_enrolled_list: responseJson.data, aircraft_selected: 1, overlay: {message: '', type: '', status: 'closed'}});
        }).then(() => {
        var url = config.get('api') + '/tripulantes/ativos/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({staff_list: responseJson.data, overlay: {message: '', type: '', status: 'closed'}});
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }); /* Overlay */ }); /* lista de tripulantes */
      });
    }
    this.setState(change);
  }

  handleSelectChangeAircraftModel(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearScheduleSelect();
    } else {
      this.handleAlert('', '', 'open');
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/escalas/aprovadas/modelo-aeronave/lista/'+event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({schedules_list: responseJson.data, aircraft_model_selected: 1, overlay: {message: '', type: '', status: 'closed'}});
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
    this.setState(change);
  }
  
  handleSelectChangeSchedule(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearAircraftSelect();
    } else {
      this.handleAlert('', '', 'open');
      change[name] = event.value;
      var datasave = {
        schedule_id: event.value,
        aircraft_model_id: this.state.aircraft_model_id,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/aeronaves/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({aircrafts_list: responseJson.data, schedule_selected: 1, overlay: {message: '', type: '', status: 'closed'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    this.setState(change);
  }
  
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
      var today = new Date().toISOString().slice(0,10);
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date: today_str});
      this.setState({date_start: today_str});
      this.setState({date_finish: today_str});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronaves/modelos/escaladas/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  clearScheduleSelect() {
    this.setState({staff_list: []});
    this.setState({staff__enrolled_list: []});
    this.setState({schedules_list: []});
    this.setState({aircrafts_list: []});
    this.setState({aircraft_selected: 0});
    this.setState({schedule_selected: 0});
    this.setState({aircraft_model_selected: 0});
    this.setState({schedule_id: null});
    this.setState({schedule_grade_aircraft_id: null});
    this.setState({schedule_grade_aircraft_staff_id: null});
    this.setState({staff_id: null});
    this.setState({staff_enrolled_id: null});
  }

  clearAircraftSelect() {
    this.setState({aircrafts_list: []});
    this.setState({staff_list: []});
    this.setState({staff__enrolled_list: []});
    this.setState({aircraft_selected: 0});
    this.setState({schedule_selected: 0});
    this.setState({schedule_grade_aircraft_id: null});
    this.setState({staff_id: null});
    this.setState({staff_enrolled_id: null});
  }

  clearStaffSelect() {
    this.setState({staff_list: []});
    this.setState({staff__enrolled_list: []});
    this.setState({aircraft_selected: 0});
    this.setState({schedule_grade_aircraft_id: null});
    this.setState({staff_id: null});
    this.setState({staff_enrolled_id: null});
  }
  
  test(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = this.state;

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/testar/alertas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
          self.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }



  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Voos.TesteDeAlerta.titulo}</h3>
      <hr/>
      <form onSubmit={this.test}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Voos.TesteDeAlerta.formulario.Frotas}:</label>
              <Select
                className=""
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Voos.TesteDeAlerta.formulario.placeholder.SelecionarFrota}
                onChange={this.handleSelectChangeAircraftModel.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
          {this.state.aircraft_model_selected === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Voos.TesteDeAlerta.formulario.Escalas}:</label>
                <Select
                  className=""
                  name="schedule_id"
                  value={this.state.schedule_id}
                  searchable={true}
                  placeholder={this.locale.Voos.TesteDeAlerta.formulario.placeholder.SelecionarEscala}
                  onChange={this.handleSelectChangeSchedule.bind(this, 'schedule_id')}
                  options={this.state.schedules_list}
                />
              </div>
            </div>
            : 
            ""
          }
        </div>
        <div className="row">
          {this.state.schedule_selected === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Voos.TesteDeAlerta.formulario.Aeronaves}:</label>
                <Select
                  className=""
                  name="schedule_grade_aircraft_id"
                  value={this.state.schedule_grade_aircraft_id}
                  searchable={true}
                  placeholder={this.locale.Voos.TesteDeAlerta.formulario.placeholder.SelecionarAeronave}
                  onChange={this.handleSelectChangeAircraft.bind(this, 'schedule_grade_aircraft_id')}
                  options={this.state.aircrafts_list}
                />
              </div>
            </div>
            : 
            ""
          }
          {this.state.aircraft_selected === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Voos.TesteDeAlerta.formulario.Tripulantes}:</label>
                <Select
                  className=""
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.Voos.TesteDeAlerta.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />
              </div>
            </div>
            : 
            ""
          }
        </div>
        <div className="row">
          {this.state.aircraft_selected === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Voos.TesteDeAlerta.formulario.TripulanteSubstituido}:</label>
                <Select
                  className=""
                  name="staff_enrolled_id"
                  value={this.state.staff_enrolled_id}
                  searchable={true}
                  placeholder={this.locale.Voos.TesteDeAlerta.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChange.bind(this, 'staff_enrolled_id')}
                  options={this.state.staff_enrolled_list}
                />
              </div>
            </div>
            : 
            ""
          }
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Voos.TesteDeAlerta.formulario.botaoTestarAlertas}</button>
      </form>
      <hr/>
      {
        (typeof self.state.alerts.global_alerts !== 'undefined') ?
        <div>
          {Object.keys(self.state.alerts.global_alerts).map(function(k) {
            var alert = self.state.alerts.global_alerts[k];
            if (alert.status === 'danger') {
              return(
                <div className={"box-alert box-alert-" + alert.color}>
                  <h4><strong>{alert.title}</strong></h4>
                    <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                </div>
              );
            } else {
              return(
                ''
              );
            }
          })}
          <hr/>
        </div>
        :
        ''
      }
      {
        (typeof self.state.alerts.personal_alerts !== 'undefined') ?
        <div>
          {Object.keys(self.state.alerts.personal_alerts).map(function(nickname) {
            var alerts = self.state.alerts.personal_alerts[nickname];
            return(
              <div>
                <h4><strong>{nickname}</strong></h4>
                <h5><strong>{this.locale.Voos.TesteDeAlerta.erros}</strong></h5>
                {Object.keys(alerts).map(function(k) {
                  var alert = alerts[k];
                  if (alert.status === 'danger') {
                    return(
                      <div className={"box-alert box-alert-" + alert.color}>
                          <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                      </div>
                    );
                  } else {
                    return(
                      ''
                    );
                  }
                })}
                {/*
                 <h5><strong>Aprovado</strong></h5>
                }
                {Object.keys(alerts).map(function(k) {
                  var alert = alerts[k];
                  if (alert.status === 'success') {
                    return(
                      <div className={"box-alert box-alert-" + alert.color}>
                          <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                      </div>
                    );
                  } else {
                    return(
                      ''
                    );
                  }
                })}
              */}
                <hr/>
              </div>
            );
          })}
        </div>
        :
        ''
      }
    </div>
  </div>
</div>
    );
  }
}

export default TestAlertsIndex;



// WEBPACK FOOTER //
// ./src/Components/Flights/TestAlertsIndex.js